import { Box, Flex, Text } from "@chakra-ui/react";
import { Activity, BriefcaseBusiness, CalendarDays, ClipboardCheck, LayoutDashboard, Library, Mail, Users } from "lucide-react";
import { NavLink, Navigate, Outlet } from "react-router-dom";

import { UserWeddingRole } from "../../../types/wedding";
import { ClientStorage, ClientStorageItem } from "../../../utils/clientstorage";

const links = [
  { to: "/planner", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/planner/weddings", label: "Weddings", icon: CalendarDays },
  { to: "/planner/calendar", label: "Calendar", icon: CalendarDays },
  { to: "/planner/tasks", label: "Tasks", icon: ClipboardCheck },
  { to: "/planner/team", label: "Team", icon: Users },
  { to: "/planner/templates", label: "Templates", icon: Library },
  { to: "/planner/activity", label: "Activity", icon: Activity },
  { to: "/planner/invitations", label: "Invitations", icon: Mail },
];

const PlannerWorkspaceLayout = () => {
  const role = ClientStorage.fetch<UserWeddingRole>(ClientStorageItem.UserWeddingRole);
  if (role !== UserWeddingRole.EventPlanner) return <Navigate to="/" replace />;

  return (
    <Flex w="full" maxW="1440px" minW={0} mx="auto" px={{ base: 4, md: 7 }} gap={6} align="flex-start" overflowX="clip">
      <Box display={{ base: "none", lg: "block" }} position="sticky" top="92px" w="220px" flexShrink={0} bg="white" border="1px solid #E5E5E0" borderRadius="16px" p={3}>
        <Flex px={3} py={3} align="center" gap={2}><BriefcaseBusiness size={19} /><Text fontWeight={700}>Planner workspace</Text></Flex>
        <Box mt={2}>
          {links.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end}>
              {({ isActive }) => <Flex mt={1} px={3} py={3} align="center" gap={3} borderRadius="10px" bg={isActive ? "#F1F1ED" : "transparent"} fontWeight={isActive ? 600 : 400}><Icon size={18} /><Text fontSize="14px">{label}</Text></Flex>}
            </NavLink>
          ))}
        </Box>
      </Box>
      <Box minW={0} maxW="full" flex={1}><Outlet /></Box>
    </Flex>
  );
};

export default PlannerWorkspaceLayout;
